import Icon from "@material-ui/core/esm/Icon";
import Tooltip from "@material-ui/core/esm/Tooltip";
import NavigateBefore from "@material-ui/icons/esm/NavigateBefore";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import useStyles from './ButtonStyles';
export default function BackButton({
  children,
  to
}) {
  const {
    backButton,
    backButtonLink
  } = useStyles();
  const {
    t
  } = useTranslation();
  const backTitle = t('buttons.back');
  return /*#__PURE__*/React.createElement("div", {
    className: backButton
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: backTitle
  }, /*#__PURE__*/React.createElement(NavLink, {
    "aria-label": `link to ${to}`,
    to: to || '',
    className: backButtonLink
  }, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(NavigateBefore, null)))), children);
}
BackButton.defaultProps = {
  to: undefined
};